import { useReducer, useEffect } from "react";

import { gql } from "apollo-boost";

import ApolloClient from "../services/apollo";

import { useCarsState } from "../interfaces/car";

import { Action, stateSwitch } from "../interfaces/request";

const QUERY_CARS = gql`
  query carsSchedules {
    getCars {
      id
      max
      number
      board
    }
  }
`;

const initialState: useCarsState = {
  list: [],
  error: false,
  loading: true,
  success: false,
};

const reducer = (state: useCarsState, action: Action): useCarsState => {
  switch (action.type) {
    case "list":
      return {
        ...state,
        list: [...state.list, ...action.value],
      };
    default:
      return stateSwitch(state, action);
  }
};

export const useCars = () => {
  const [reducerOptions, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      dispatch({ type: "loading", value: true });
      const { data } = await ApolloClient.query({
        query: QUERY_CARS,
        fetchPolicy: "no-cache",
      });
      dispatch({ type: "loading", value: false });
      dispatch({
        type: "list",
        value: data.getCars,
      });
    } catch (err) {
      dispatch({ type: "loading", value: false });
      dispatch({
        type: "error",
        value: true,
      });
    }
  };

  return {
    ...reducerOptions,
  };
};
